/*
 *
 * Options constants
 *
 */

export const SELECT_APPOINTMENT_BOOKING_CARD = 'app/Options/SELECT_APPOINTMENT_BOOKING_CARD';
export const OPTIONS_LOADED = 'app/Options/OPTIONS_LOADED';
export const SELECT_MATERIAL = 'app/Options/SELECT_MATERIAL';
export const SELECT_EXPRESSION = 'app/Options/SELECT_EXPRESSION';
export const SELECT_COVER_PANEL = 'app/Options/SELECT_COVER_PANEL';
export const SELECT_EDGE = 'app/Options/SELECT_EDGE';
export const SELECT_WALL_LOCATION = 'app/Options/SELECT_WALL_LOCATION';
export const SELECT_KITCHEN_ISLAND_WALL_LOCATION = 'app/Options/SELECT_KITCHEN_ISLAND_WALL_LOCATION';
export const SELECT_THICKNESS = 'app/Options/SELECT_THICKNESS';
export const SELECT_SPLASHBACK = 'app/Options/SELECT_SPLASHBACK';
export const SET_WALL_PANEL_HEIGHT = 'app/Options/SET_WALL_PANEL_HEIGHT';
export const SET_WALL_EDGING_STRIP_HEIGHT = 'app/Options/SET_WALL_EDGING_STRIP_HEIGHT';
export const SELECT_WALL_PANEL_MATERIAL = 'app/Options/SELECT_WALL_PANEL_MATERIAL';
export const SELECT_WALL_EDGING_STRIP_MATERIAL = 'app/Options/SELECT_WALL_EDGING_STRIP_MATERIAL';
export const SELECT_WALL_EDGING_STRIP_CUSTOMIZABLE_MATERIAL = 'app/Options/SELECT_WALL_EDGING_STRIP_CUSTOMIZABLE_MATERIAL';
export const SELECT_NO_MATERIAL_WALL_PANEL_MATERIAL = 'app/Options/SELECT_NO_MATERIAL_WALL_PANEL_MATERIAL';
export const SELECT_WALL_PANEL_EXPRESSION = 'app/Options/SELECT_WALL_PANEL_EXPRESSION';
export const SELECT_SINK_MATERIAL = 'app/Options/SELECT_SINK_MATERIAL';
export const SELECT_SINK_MODEL = 'app/Options/SELECT_SINK_MODEL';
export const SELECT_SINK_FASTENING = 'app/Options/SELECT_SINK_FASTENING';
export const SELECT_DRAINER_GROOVES = 'app/Options/SELECT_DRAINER_GROOVES';
export const SELECT_KITCHEN_ISLAND = 'app/Options/SELECT_KITCHEN_ISLAND';
export const SELECT_KITCHEN_ISLAND_MATERIAL = 'app/Options/SELECT_KITCHEN_ISLAND_MATERIAL';
export const SELECT_NO_MATERIAL_KITCHEN_ISLAND_MATERIAL = 'app/Options/SELECT_NO_MATERIAL_KITCHEN_ISLAND_MATERIAL';
export const SELECT_KITCHEN_ISLAND_EXPRESSION = 'app/Options/SELECT_KITCHEN_ISLAND_EXPRESSION';
export const SELECT_KITCHEN_ISLAND_COVER_PANEL = 'app/Options/SELECT_KITCHEN_ISLAND_COVER_PANEL';
export const SELECT_KITCHEN_ISLAND_EDGE = 'app/Options/SELECT_KITCHEN_ISLAND_EDGE';
export const SELECT_KITCHEN_ISLAND_THICKNESS = 'app/Options/SELECT_KITCHEN_ISLAND_THICKNESS';
export const SELECT_KITCHEN_ISLAND_SAME_AS_WORKTOP = 'app/Options/SELECT_KITCHEN_ISLAND_SAME_AS_WORKTOP';
export const SELECT_NO_MATERIAL_KITCHEN_ISLAND_SAME_AS_WORKTOP = 'app/Options/SELECT_NO_MATERIAL_KITCHEN_ISLAND_SAME_AS_WORKTOP';
export const SELECT_WALL_PANEL_MATCH_WORKTOP = 'app/Options/SELECT_WALL_PANEL_MATCH_WORKTOP';
export const SELECT_NO_MATERIAL_WALL_PANEL_MATCH_WORKTOP = 'app/Options/SELECT_NO_MATERIAL_WALL_PANEL_MATCH_WORKTOP';
export const SELECT_KITCHEN_ISLAND_OVERHANG = 'app/Options/SELECT_KITCHEN_ISLAND_OVERHANG';
export const SET_DOUBLE_SIDED = 'app/Options/SET_DOUBLE_SIDED';
export const SELECT_KITCHEN_ISLAND_OVERHANG_SIDE = 'app/Options/SELECT_KITCHEN_ISLAND_OVERHANG_SIDE';
export const SET_KITCHEN_ISLAND_MEASUREMENTS = 'app/Options/SET_KITCHEN_ISLAND_MEASUREMENTS';
export const SET_KITCHEN_ISLAND_DOUBLE_SIDED = 'app/Options/SET_KITCHEN_ISLAND_DOUBLE_SIDED';
export const SELECT_KITCHEN_ISLAND_SPLASH_BACK = 'app/Options/SELECT_KITCHEN_ISLAND_SPLASH_BACK';
export const SET_KITCHEN_ISLAND_OVERHANG_FIELD = 'app/Options/SET_KITCHEN_ISLAND_OVERHANG_FIELD';
export const SELECT_OVERHANG = 'app/Options/SELECT_OVERHANG';
export const SELECT_OVERHANG_SIDE = 'app/Options/SELECT_OVERHANG_SIDE';
export const SELECT_NO_MATERIAL_OVERHANG = 'app/Options/SELECT_NO_MATERIAL_OVERHANG';
export const SET_OVERHANG_FIELD = 'app/Options/SET_OVERHANG_FIELD';
export const LOAD_PLAN = 'app/Options/LOAD_PLAN';
export const NEW_PLAN = 'app/Options/NEW_PLAN';
export const SAVE_PLAN = 'app/Options/SAVE_PLAN';
export const SET_PLAN_NAME = 'app/Options/SET_PLAN_NAME';
export const SET_PLAN_CODE = 'app/Options/SET_PLAN_CODE';
export const PLAN_SAVED = 'app/Options/PLAN_SAVED';
export const PLAN_LOADED = 'app/Options/PLAN_LOADED';
export const PLAN_LOAD_FAILED = 'app/Options/PLAN_LOAD_FAILED';
export const PLAN_LOADING = 'app/Options/PLAN_LOADING';
export const LOAD_DATA = 'app/Options/LOAD_DATA';
export const LOADING_DATA = 'app/Options/LOADING_DATA';
export const LOADING_ERROR = 'app/Options/LOADING_ERROR';
export const CHANGE_SHAPE = 'app/Options/CHANGE_SHAPE';
export const CHANGE_DEFAULT_SHAPE = 'app/Options/CHANGE_DEFAULT_SHAPE';
export const NO_MATERIAL_CHANGE_SHAPE = 'app/Options/NO_MATERIAL_CHANGE_SHAPE';
export const RESET_PLAN = 'app/Options/RESET_PLAN';
export const CHANGE_CUTOUTS = 'app/Options/CHANGE_CUTOUTS';
export const CHANGE_FREESTANDING_HOBS = 'app/Options/CHANGE_FREESTANDING_HOBS';
export const SET_FREESTANDING_HOB_WIDTH = 'app/Options/SET_FREESTANDING_HOB_WIDTH';
export const CHANGE_SINGLE_CUTS = 'app/Options/CHANGE_SINGLE_CUTS';
export const CHANGE_DOUBLE_CUTS = 'app/Options/CHANGE_DOUBLE_CUTS';
export const CHANGE_TRIPLE_CUTS = 'app/Options/CHANGE_TRIPLE_CUTS';
export const CHANGE_HIGH_CABINET_JOINTS = 'app/Options/CHANGE_HIGH_CABINET_JOINTS';
export const CHANGE_ROUNDED_CORNERS = 'app/Options/CHANGE_ROUNDED_CORNERS';
export const CHANGE_INVERTED_CORNERS = 'app/Options/CHANGE_INVERTED_CORNERS';
export const CHANGE_TAP_HOLES = 'app/Options/CHANGE_TAP_HOLES';
export const REVERT_PLAN = 'app/Options/REVERT_PLAN';
export const UNDO_CHOICE = 'app/Options/UNDO_CHOICE';
export const PARAMETER_SEEN = 'app/Options/PARAMETER_SEEN';
export const RESET_NUMERICAL_PARAMETER = 'app/Options/RESET_NUMERICAL_PARAMETER';
export const NO_MATERIAL_RESET_NUMERICAL_PARAMETER = 'app/Options/NO_MATERIAL_RESET_NUMERICAL_PARAMETER';
export const RESET_WORKTOP_SHAPE_MEASUREMENTS = 'app/Options/RESET_WORKTOP_SHAPE_MEASUREMENTS';
export const RESET_PREVIOUS_SINK_MODEL = 'app/Options/RESET_PREVIOUS_SINK_MODEL';

export const CHANGE_WALL_PANEL_ROUND_CUTS_SMALL = 'app/Options/CHANGE_WALL_PANEL_ROUND_CUTS_SMALL';
export const CHANGE_WALL_PANEL_ROUND_CUTS_BIG = 'app/Options/CHANGE_WALL_PANEL_ROUND_CUTS_BIG';
export const CHANGE_WALL_PANEL_SQUARE_CUTS = 'app/Options/CHANGE_WALL_PANEL_SQUARE_CUTS';
export const CHANGE_WALL_PANEL_SINGLE_CUTS = 'app/Options/CHANGE_WALL_PANEL_SINGLE_CUTS';
export const CHANGE_WALL_PANEL_DOUBLE_CUTS = 'app/Options/CHANGE_WALL_PANEL_DOUBLE_CUTS';
export const CHANGE_WALL_PANEL_TRIPLE_CUTS = 'app/Options/CHANGE_WALL_PANEL_TRIPLE_CUTS';

export const CHANGE_KITCHEN_ISLAND_SINGLE_CUTS = 'app/Options/CHANGE_KITCHEN_ISLAND_SINGLE_CUTS';
export const CHANGE_KITCHEN_ISLAND_ROUNDED_CORNERS = 'app/Options/CHANGE_KITCHEN_ISLAND_ROUNDED_CORNERS';
export const CHANGE_KITCHEN_ISLAND_SQUARE_CUTS = 'app/Options/CHANGE_KITCHEN_ISLAND_SQUARE_CUTS';


export const SET_SHAPE_FIELD = 'app/Options/SET_SHAPE_FIELD';

export const CHECK_FOR_NEW_FEATURES = 'app/Options/CHECK_FOR_NEW_FEATURES';
